
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.156 13.159l-.079-.07L.244 7.256.23 7.242a.837.837 0 01-.053-.062l.067.076A.84.84 0 010 6.666L0 6.622l.003-.033L0 6.667a.83.83 0 01.175-.511l.012-.016a.836.836 0 01.046-.052l.011-.01L6.077.243a.833.833 0 011.248 1.1l-.07.079-4.408 4.41h15.438a.833.833 0 01.098 1.661l-.098.006H2.845l4.41 4.41c.301.301.324.774.07 1.1l-.07.08c-.3.3-.772.323-1.1.069z","fill":"#000"}})])
          )
        }
      }
    